<template>
  <div>
    <PageHeader
      main-header="common.restaurant-name"
      :note="$auth.isAuthenticated ? null : 'home.price-info'"
      showHeaderMobile
      class="mb-4"
    >
      <template v-slot:note v-if="!$auth.isAuthenticated">
        <span>{{ $t('home.price-info') }}</span
        ><br />
        <span>({{ $t('home.image-reference') }})</span>
      </template>
    </PageHeader>
    <router-view></router-view>
    <v-btn
      v-if="showScan"
      fixed
      color="primary"
      fab
      bottom
      right
      @click.stop="$mitt.emit('openQrScanDialog')"
    >
      <v-icon>$qrScan</v-icon>
    </v-btn>
  </div>
</template>

<script>
import PageHeader from '@/components/common/PageHeader'
import { isMobileOnly } from 'mobile-device-detect'

export default {
  name: 'HomeView',

  components: {
    PageHeader
  },

  computed: {
    showScan() {
      return isMobileOnly
    }
  }
}
</script>
